export const getCommentsDataManagerExperimentAttributes = (): {
	newDataManagerEnabled: true;
} => ({
	newDataManagerEnabled: true,
});
